import styled from 'styled-components';

export const SVGElem = styled.svg`
  fill: none;
`;

export const RectElem = styled.rect`
  ${({ theme }) => `
    fill: ${theme.colors.neutral.primary[10]};
    stroke: ${theme.colors.neutral.primary[30]};
  `};
`;

export const PathElem = styled.path``;

export const LineElem = styled.line`
  ${({ theme }) => `
    stroke: ${theme.colors.neutral.primary[30]};
  `};
`;
